// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__vsxjN","list":"BalanceDue_list__1JJlU","listRow":"BalanceDue_listRow__cadjn","total":"BalanceDue_total__Vv3FE"};